<template>
    <el-dialog title="" :visible.sync="show" :modal="true" :close-on-click-modal="false" class="deleteDialog" :append-to-body="true" ref="deleteDialog" @close="cancelDialog">
        <div class="content">
            <div class="top">
                <div>
                    <i class="icon-inotice"></i>
                </div>
                <h1 v-html="title"></h1>
                <h2>{{content}}</h2>
            </div>
            <div class="footer">
                <el-button type="primary" @click="cancelDialog">取&nbsp;&nbsp;消</el-button>
                <el-button type="primary" @click="confirmDialog">确&nbsp;&nbsp;定</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'deleteDialog',
    data() {
        return {
            show: false,
            title: '',
            content: ''
        };
    },
    computed: {},
    components: {},
    watch: {},
    mounted() {

    },
    methods: {
        cancelDialog() {
            this.show = false;
            this.cancel.call(this);
        },
        confirmDialog() {
            this.confirm.call(this);

            this.show = false;
        },
    }
};
</script>
<style>
.deleteDialog {

    .el-dialog {
        width: 460px;
        box-shadow: 0 2px 10px 0 rgba(22, 51, 108, 0.39);
        margin-top: -126px !important;
        top: 50%;
    }

    .el-dialog__body {
        padding: 20px 20px 40px;
    }

    .content {
        text-align: center;

        .top {
            .icon-inotice {
                font-size: 27px;
            }

            h1 {
                font-size: 14px;
                color: #444444;
                margin-top: 37px;
                font-weight: normal;

                em {
                    color: #044CA1;
                }
            }

            h2 {
                font-size: 10px;
                color: #AAAAAA;
                margin-top: 15px;
                font-weight: normal;
            }
        }

        .footer {
            margin-top: 33px;
            display: flex;
            align-items: center;
            justify-content: space-evenly;

            .el-button--primary {
                width: 80px;
                height: 26px;
                margin: 0;
            }
        }
    }
}
</style>